// store/trendReportSlice.js

import { createSlice } from "@reduxjs/toolkit";
 

const initialState = {
  data: {
    business: null,
    sales: [],
    summary: {
      totalSalePrice: 0,
      totalFinalPrice: 0,
      totalItems: 0,
      totalQuantity: 0,
    },
   
  },
  loading: false,
  error: null,
};

const SaleReportSaleTrand = createSlice({
  name: "trendReport",
  initialState,
  reducers: {
    trendReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    trendReportSuccess(state, action) {
      const { business, sales, summary } = action.payload.data;

      state.loading = false;
      state.data = {
        ...state.data,
        business,
        sales,
        summary,
        filters: {
          ...state.data.filters,
          ...action.payload.data.filters, // optional: if backend sends back applied filters
        },
      };
    },
    trendReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload || "Failed to fetch trend report";
    },
    resetTrendReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
    
  },
});

export const {
  trendReportRequest,
  trendReportSuccess,
  trendReportFailure,
  resetTrendReport,

} = SaleReportSaleTrand.actions;

export default SaleReportSaleTrand.reducer;
